// extracted by mini-css-extract-plugin
export var dataCell = "_jv-2";
export var dataRow = "_jv-0";
export var headerRow = "_jv-1";